<template>
  <b-tabs v-if="isDone && renderPage">
    <b-tab
      v-if="isDone"
      :disabled="transactionIsntBankSlip"
    >
      <template #title>
        <feather-icon icon="UserIcon" />
        <span>Boleto</span>
      </template>
      <bankSlip
        v-if="bankSlipPermission"
        :customer="customer"
      />
      <noPermission v-else />
    </b-tab>
    <b-tab
      v-if="isDone"
      :disabled="transactionIsntRecurrence"
    >
      <template #title>
        <feather-icon icon="LinkIcon" />
        <span>Recorrência</span>
      </template>
      <recurrence
        v-if="recurrencePermission"
        :customer="customer"
      />
      <noPermission v-else />
    </b-tab>
    <b-tab
      v-if="isDone"
      :disabled="transactionIsntDirectSale"
      active
    >
      <template #title>
        <feather-icon icon="LockIcon" />
        <span>Link Pagamento</span>
      </template>
      <directSale
        v-if="directSalePermission"
        :customer="customer"
      />
      <noPermission v-else />
    </b-tab>
  </b-tabs>
</template>

<script>
import {
  BTabs,
  BTab,
} from 'bootstrap-vue'
import bankSlip from './BankSlip.vue'
import recurrence from './Recurrence.vue'
import directSale from './DirectSale.vue'
import noPermission from '@/views/error/NoPermission.vue'
import { getClient } from '@/service/client/client'
import { callLoading } from '@/service/utilities/utilities'

import { getMerchantData } from '@/utils/get-merchant-data'

export default {
  res: {},
  components: {
    BTabs,
    BTab,
    bankSlip,
    recurrence,
    noPermission,
    directSale,
  },
  data() {
    return {
      transactionIsntBankSlip: false,
      transactionIsntRecurrence: false,
      transactionIsntDirectSale: false,
      type: null,
      isDone: false,
      customer: {
        isTrue: false,
      },
      bankSlipPermission: false,
      directSalePermission: false,
      recurrencePermission: false,
      userPermission: null,
      permission_option: null,
      renderPage: true,

      id: window.location.pathname.split('/')[2],
    }
  },
  beforeRouteLeave(to, from, next) {
    this.renderPage = false
    next()
  },
  async created() {
    callLoading(true)
    await this.checkPermission()
    if (this.id) {
      if (!this.$route.query.type) { this.$router.push('/error-404') } else { this.type = this.$route.query.type }
      await this.disablesTabUseless()
      await this.getClient()
    }
    this.isDone = true
    callLoading(false)
  },
  methods: {
    async checkPermission() {
      const permissions = getMerchantData().permissions.map(permission => +permission)

      this.directSalePermission = permissions.some(permission => permission === 3)
      this.bankSlipPermission = permissions.some(permission => permission === 4)
      this.recurrencePermission = permissions.some(permission => permission === 5)
    },

    disablesTabUseless() {
      if (this.type) {
        if (this.type === 'boleto') {
          this.transactionIsntRecurrence = true
          this.transactionIsntDirectSale = true
        } else if (this.type === 'recorrencia') {
          this.transactionIsntBankSlip = true
          this.transactionIsntDirectSale = true
        } else if (this.type === 'venda-direta') {
          this.transactionIsntBankSlip = true
          this.transactionIsntRecurrence = true
        } else {
          this.type = this.$route.query.type
        }
      }
    },

    async getClient() {
      try {
        const { data } = await getClient(this.id)
        const {
          name, email, phone, tax_id, id,
        } = data

        this.customer = {
          name,
          email,
          phone,
          tax_id,
          customer_id: id,
          isTrue: true,
        }
        this.isDone = true
      } finally {
        this.renderPage = true
      }
    },
  },
}
</script>
